import { render, staticRenderFns } from "./ProfileLayout.vue?vue&type=template&id=a8ade9e2"
import script from "./ProfileLayout.vue?vue&type=script&lang=js"
export * from "./ProfileLayout.vue?vue&type=script&lang=js"
import style0 from "./ProfileLayout.vue?vue&type=style&index=0&id=a8ade9e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports